<template>
  <div>
    <p>
      <strong>{{ tn("autoRenewOffLine1") }}</strong>
    </p>
    <ul class="tight mt mb">
      <li>
        <em>{{ tn("subscription") }}</em>
        {{ subscriptionName }}
      </li>
      <li>
        <em>{{ tn("computer") }}</em>
        {{ computerName }}
      </li>
      <li>
        <em>{{ tn("expires") }}</em>
        {{ formatExpirationDate(expiresOn) }}
      </li>
    </ul>
    <p>{{ tn("notifyProtection") }}</p>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, ref, computed } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { ISubscription } from "@/common/api/unifiedPortal/interfaces";
import { formatDateString } from "@/common/dateFormat";

const componentName = "AutoRenewTurnOffComponent";

export default defineComponent({
  name: componentName,
  props: {
    subscription: {
      type: Object as PropType<ISubscription>,
      required: true,
    },
  },

  setup(props) {
    logEvent("created", componentName, props.subscription);
    const subscriptionName = ref<string>(props.subscription?.productDisplayName ?? "");
    const expiresOn = ref<string>(props.subscription?.expirationDate ?? "");

    const computerName = computed(() => {
      return props.subscription?.computer?.description ?? props.subscription?.computer?.name ?? "";
    });

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function formatExpirationDate(expirationDate: string) {
      return formatDateString(expirationDate);
    }

    //Expose to template
    return {
      tn,
      subscriptionName,
      computerName,
      expiresOn,
      formatExpirationDate,
    };
  },
});
</script>
<style scoped lang="css">
@import "@/styles/variables.css";
</style>
